// extracted by mini-css-extract-plugin
export default {"wrapper":"job-card_wrapper__AIs3R","text_wrapper":"job-card_text_wrapper__aAkrN","title":"job-card_title__u+6Xl","text":"job-card_text__A5CgS","button":"job-card_button__rTV2P"};